module.exports = __webpack_public_path__ + "img/57_18.2d4527f3.png";